import { withStyles } from "@material-ui/core/styles";
import LikeIcon from "./LikeIcon";
import styles from "./styles";

export default withStyles(styles)(LikeIcon);
